import FaqSection from '@/v2/components/sections/common/faq-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import HeroSection from '@/v2/components/sections/common/hero-section'
import InfoTabsSection from '@/v2/components/sections/common/info-tabs-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import ServiceTipsSectionSection from '@/v2/components/sections/common/service-tips-section'

import {
  faqSectionContent,
  helperSectionContent,
  heroSectionContent,
  infoTabsSectionSectionContent,
  promotionalBannerSectionContent,
  serviceTipsSectionContent,
  whyChooseShipAndStorageSectionContent
} from '@/v2/constants/pages/public-pages/what-we-store-page'

interface WhatWeStorePageProps {}

const WhatWeStorePage: React.FC<WhatWeStorePageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        imgClassName=' 
          w-[324px] h-[218px] 
          md-mn:w-[380px] md-mn:h-[286px] 
          lg:!w-[448px] lg:!h-[313px] 
          xl-min:!w-[680px] xl-min:!h-[458px]'
        btnClassName='xl-min:!w-[233px] xl-min:!h-[50px] lg-mn:w-[240px] md-mn:w-[186px] w-[238px] h-[44px]'
        className='xl-min:[&>div:first-child]:!max-w-[745px] lg-mn:[&>div:first-child]:max-w-[436px]'
      />
      <ServiceTipsSectionSection
        isBgDark
        {...serviceTipsSectionContent}
        className={`
          [&>div>div:nth-of-type(2)]:md-mn:grid-cols-3
          [&_article]:text-center
          [&_article_div]:w-full md-mn:[&_article]:px-0 
          [&_article]:px-6 
          [&_h3]:text-center 
          `}
      />
      <InfoTabsSection
        {...infoTabsSectionSectionContent}
        className='[&_button]:!w-[278px] [&_article]:bg-white [&_article]:shadow-xl xl-min:[&>div>div:last-of-type]:gap-5'
        imgClassName='xl-min:!w-[516px] xl-min:!h-[395px] w-[300px] h-[230px]'
        sectionTitleClassName='[&_p]:lg-mn:w-full [&_p]:md-mn:w-[50%] [&_p]:w-[90%] [&_h2]:md-mn:w-full [&_h2]:w-[90%]'
      />
      <HelperSection
        isBgDark
        {...helperSectionContent}
        imgClassName='xl-min:!w-[618px] xl-min:!h-[387px] md-mn:w-[450px] md-mn:h-[252px] w-[350px] h-[196px]'
        className={`
            [&_ul]:space-y-3
            xl-min:[&>div>div:last-of-type>div]:!flex-row
            [&>div>div:last-of-type>div]:flex-col
            `}
        sectionTitleClassName='xl-min:!w-full md-mn:w-[373px] [&_p]:md-mn:w-full [&_p]:w-[80%]'
      />
      <ServiceTipsSectionSection
        {...whyChooseShipAndStorageSectionContent}
        sectionTitleClassName='[&_p]:xl-min:!w-[55%] [&_p]:lg-mn:w-[65%] [&_p]:md-mn:w-[90%]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:!w-[559px] xl-min:!h-[316px] lg-mn:w-[340px] md-mn:w-[308px] w-[340px] h-[202px]'
        className={`
          md-mn:[&_h3]:w-full
          [&_h3]:w-[80%] 
          [&_h3]:mx-auto
          xl-min:[&_button]:!w-[242px]
          lg-mn:[&_button]:w-[236px]
          md-mn:[&_button]:w-[229px]
          [&_button]:w-[229px]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default WhatWeStorePage
